// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rai-app-md .message-data,.rai-app-sm .message-data,.rai-app-xl .message-data,.rai-app.lg .message-data{height:inherit;display:grid;grid-template-rows:calc(100% - 52px) 52px}.rai-app-md .message-data .message-data__thread,.rai-app-sm .message-data .message-data__thread,.rai-app-xl .message-data .message-data__thread,.rai-app.lg .message-data .message-data__thread{overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
